module.exports = __webpack_public_path__ + "static/img/图层 540.a6644010.png";